import React = require('react');
import { IPremium } from '../../../../../data/api/models';
import { FormattedNumber } from 'react-intl';
import { format } from 'date-fns';
import { get } from 'lodash';

interface FooterPriceDisplay {
  tripType: string,
  premium: IPremium,
}

export const FooterPriceDisplay = ({ tripType, premium }: FooterPriceDisplay) => {
  const validUntil = get(premium, 'validUntil') ? format(new Date(get(premium, 'validUntil')), 'dd/MM/yyyy') : '';
  return (
    <div className={'footer-price-display'}>
      <img src={require('../../../img/payment.svg')} alt="Admiral"/> Total to pay by card
      <div className={'price-display-value'}>
        {premium && (
          <FormattedNumber
            value={premium.gross}
            style="currency"
            currency={premium.currency}
          />
        )}
        {tripType === 'annual' && (
          <span className={'price-affix'}> year</span>
        )}
      </div>
      <div className={'price-info'}>Figures include all applicable taxes</div>
      <div className={'price-info'}>Your quote is valid until {validUntil}</div>
    </div>
  )
};
